import React from 'react';
import {createRoutesFromChildren, matchRoutes, useLocation, useRoutes} from 'react-router-dom';
import CanonicalMeta from '../components/PageMeta/CanonicalMeta';
import {getCanonicalPath} from './canonical';

// Share the actual route configuration with React Router, so unknown URLs do
// not receive canonical tags and new public routes need no second URL list.
export default function CanonicalRoutes({children}) {
    const routes = createRoutesFromChildren(children);
    const location = useLocation();
    const element = useRoutes(routes);
    const pathname = getCanonicalPath(matchRoutes(routes, location));

    return (
        <>
            <CanonicalMeta pathname={pathname} search={location.search}/>
            {element}
        </>
    );
}
